import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { Button } from '~/shared/ui/Buttons'
import { FormProvider, TextInput } from '~/shared/ui/form'
import { myPalette } from '~/shared/ui/theme'
import { formSchema, FormValues } from './model'

type FormProps = {
  defaultValues: Partial<FormValues>
  onSuccess: (formValues: FormValues) => void
  isSubmitting: boolean
}

export function Form({ defaultValues, onSuccess, isSubmitting }: FormProps) {
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues,
  })

  const {
    formState: { isDirty },
  } = form

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <TextInput label='Email' name='email' autoFocus disabled={isSubmitting} />

      <div
        style={{
          fontSize: 14,
          lineHeight: '18px',
          color: myPalette.mutedText.main,
          marginBottom: '24px',
          marginTop: '16px',
        }}
      >
        На новый Email будет отправлено письмо со ссылкой для подтверждения
      </div>

      <Button
        loading={isSubmitting}
        fullWidth
        type='submit'
        variant='limeFlooded'
        size='large'
        disabled={!isDirty}
      >
        Сохранить
      </Button>
    </FormProvider>
  )
}
